<template>
    <div v-if="cookieId">
        <snoop-html-content v-if="translations.cookies[cookieId].requires" tag="p" :html="translations.cookies[cookieId].requires" />
        <snoop-html-content v-if="translations.cookies[cookieId].additionalText" tag="p" :html="translations.cookies[cookieId].additionalText" />
        <snoop-html-content
            v-else
            tag="p"
            :html="translations.cookies[cookieId].title"
            class="snoop-cookie-details__headline"
        />
        <dl class="snoop-cookie-details__content">
            <div v-for="(section, index) in sections" :key="`section-${index}`" class="snoop-cookie-details__item">
                <dt>{{ section.label }}: </dt>
                <snoop-html-content tag="dd" :html="section.value" />
            </div>
        </dl>
    </div>
</template>

<script>
import SnoopHtmlContent from './HtmlContent.vue'


export default {
    components: { SnoopHtmlContent },

    props: {
        translations: { type: Object, required: true },
        cookieId: { type: String, required: true },
    },

    computed: {
        sections () {
            return this.translations.cookies[this.cookieId].sections
        },
    },
}
</script>
